
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  install(app) {
    // Composable-like helper
    function useAcl() {
      const store = useStore();
      const can     = (slug) => store.getters.can?.(slug);
      const canAny  = (slugs) => store.getters.canAny?.(slugs);
      const canAll  = (slugs) => store.getters.canAll?.(slugs);
      const role    = computed(() => store.state.user?.role?.slug?.toLowerCase() || null);
      return { can, canAny, canAll, role };
    }

    // Global property
    app.config.globalProperties.$can = (slug) => {
      const store = app.config.globalProperties.$store || app._context.provides.store;
      return store?.getters?.can?.(slug) ?? false;
    };

    // v-can="'students.create'"
    app.directive('can', {
    mounted(el, binding) {
    const store = binding.instance?.$store || app._context.provides.store;
    const ok = store?.getters?.can?.(binding.value);
    if (!ok) el.remove();
  },
  updated(el, binding) {
    const store = binding.instance?.$store || app._context.provides.store;
    const ok = store?.getters?.can?.(binding.value);
    if (!ok && el.isConnected) el.remove();
  }
    });

    // v-can-any="['students.update','students.create']"
    app.directive('can-any', {
    mounted(el, binding) {
    const store = binding.instance?.$store || app._context.provides.store;
    const ok = store?.getters?.canAny?.(binding.value || []);
    if (!ok) el.remove();
  },
  updated(el, binding) {
    const store = binding.instance?.$store || app._context.provides.store;
    const ok = store?.getters?.canAny?.(binding.value || []);
    if (!ok && el.isConnected) el.remove();
  }
    });

    // v-role="'finance'"  OR  v-role-any="['finance','student_affairs']"
    app.directive('role', {
      mounted(el, binding, vnode) {
        const role = (vnode.ctx.$store?.state?.user?.role?.slug || '').toLowerCase();
        if (role !== String(binding.value).toLowerCase()) el.style.display = 'none';
      }
    });
    app.directive('role-any', {
      mounted(el, binding, vnode) {
        const role = (vnode.ctx.$store?.state?.user?.role?.slug || '').toLowerCase();
        const list = (binding.value || []).map(r => String(r).toLowerCase());
        if (!list.includes(role)) el.style.display = 'none';
      }
    });

    // expose useAcl for setup() components
    app.provide('useAcl', useAcl);
  }
};